import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-8956">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-8957">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-8958">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-8959" />
          <span data-id="element-8960">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-8961">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-8962">
          <div className="flex justify-between items-center" data-id="element-8963">
            <h2 className="text-xl font-bold" data-id="element-8964">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-8965">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-8966">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-8967">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-8968">
          <div className="p-6 border-r border-gray-200" data-id="element-8969">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-8970">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-8971">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-8972">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-8973">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-8974">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-8975">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-8976">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8977">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8978">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8979">
            <div data-id="element-8980">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8981">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-8982">{reservation.booking.id}</p>
            </div>
            <div data-id="element-8983">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8984">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-8985">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8986">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8987">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8988">
            <div data-id="element-8989">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8990">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-8991">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-8992">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8993">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-8994">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8995">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8996">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-8997">
            <div data-id="element-8998">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8999">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9000">{reservation.room.name}</p>
            </div>
            <div data-id="element-9001">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9002">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9003">{reservation.room.view}</p>
            </div>
            <div data-id="element-9004">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9005">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9006">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9007">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9008">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-9009">
            <h4 className="text-base font-medium mb-4" data-id="element-9010">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9011">
              <div data-id="element-9012">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9013">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9014">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-9015">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9016">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9017">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-9018">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9019">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9020">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-9021">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9022">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9023">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-9024">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9025">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9026">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-9027">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9028">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9029">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-9030">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9031">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-9032">
            <div data-id="element-9033">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9034">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9035">{reservation.rate.name}</p>
            </div>
            <div data-id="element-9036">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9037">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9038">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-9039">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9040">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-9041">
            <div className="flex justify-between" data-id="element-9042">
              <p className="text-sm text-gray-500" data-id="element-9043">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9044">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-9045">
              <p className="text-sm text-gray-500" data-id="element-9046">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9047">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-9048">
              <p className="text-sm font-medium" data-id="element-9049">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-9050">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}